import { BaseSyntheticEvent } from "react";
import { useAfricanSocialProtection } from "context/africanSocialProtection";
import { scrollIntoView } from "utils/utilities";

const useAutoComplete = () => {
    const { countrySection, setActiveFilter } = useAfricanSocialProtection();

    const handleAutocompleteChange = (
        e: BaseSyntheticEvent,
        isComparisonCountry: boolean,
        reason: string
    ) => {
        if (reason === "clear" && countrySection !== "comparison") {
            setActiveFilter({
                name: "showCountrySection",
                value: false
            });
            setActiveFilter({
                name: "activeLegendCategory",
                value: "all_subregions"
            });
            setActiveFilter({
                value: "",
                name: isComparisonCountry ? "comparisonCountry" : "country"
            });
            setActiveFilter({
                value: "",
                name: isComparisonCountry ? "comparisonCountryId" : "countryId"
            });
            setActiveFilter({
                value: "",
                name: "countryIdILO"
            });
            setActiveFilter({
                name: "countrySection",
                value: "overview"
            });
            setActiveFilter({
                name: "activeMap",
                value: "countries"
            });
            setActiveFilter({
                name: "activePage",
                value: "home"
            });
        } else {
            setActiveFilter({
                name: "showCountrySection",
                value: true
            });
            setActiveFilter({
                value: e.currentTarget.id,
                name: isComparisonCountry ? "comparisonCountry" : "country"
            });
            setActiveFilter({
                value: e.currentTarget.dataset.iso3c,
                name: isComparisonCountry ? "comparisonCountryId" : "countryId"
            });
            setActiveFilter({
                value: e.currentTarget.dataset.iso2c,
                name: "countryIdILO"
            });
            scrollIntoView();
        }
    };

    return { handleAutocompleteChange };
};

export default useAutoComplete;
